import React from "react";
import NaytaPaluuNappi from "./NaytaPaluuNappi";

const Kiitos = (props) => {
  return (
    <div>
      <strong>Kiitos tilauksesta! Saat pian sähköpostia Gaimportista!</strong>
      <br />
      <NaytaPaluuNappi />
    </div>
  );
};

export default Kiitos;
